import type { MerchantCategoryCodeSummary, NormalizedMcc } from '@ballerine/common';

/**
 * Maps digital-footprint / report `mcc` summary shape to the normalized MCC used by
 * {@link OperationalActivitySection} (same display shape as point-of-sale operational proof).
 */
export const mapMerchantCategorySummaryToNormalizedMcc = (
  summary: MerchantCategoryCodeSummary | null | undefined,
): NormalizedMcc | null => {
  const primary = summary?.primary;
  const primaryMccCode = primary?.mcc.trim();

  if (!primaryMccCode) {
    return null;
  }

  return {
    code: primaryMccCode,
    category: primary?.description ?? null,
    reasoning: primary?.reasoning ?? null,
  };
};

export const hasOperationalAnalysisFromReportData = (
  lineOfBusiness: string | null | undefined,
  summary: MerchantCategoryCodeSummary | null | undefined,
): boolean => {
  if (lineOfBusiness?.trim()) {
    return true;
  }

  return Boolean(mapMerchantCategorySummaryToNormalizedMcc(summary)?.code);
};
